module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"all":"すべて"}}')
  delete Component.options._Ctor
}
